import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getToAccounts, getFromAccounts } from '../states/accounts/selectors';
import { getSelectedPaymentId, getSelectedFromAccount } from '../states/payeeSelector/selectors';
import { getIsLCV, getPaymentTypeOrPayeeType } from '../states/modes/selectors';
import { goToPage, pages } from '../states/page/actions';
import { getPage } from '../states/page/selectors';
import { TYPE_IFT, TYPE_FASTER_PAYMENTS, TYPE_CHAPS, TYPE_BACS_CREDIT, TYPE_BACS_DEBIT } from '../config';
import { setSelectedPaymentId, setSelectedFromAccount } from '../states/payeeSelector/actions';
import { accountPropTypes } from '../sharedComponents/PayeeList/propTypes';

const mapState = (state, props) => ({
	toAccounts: props.toAccounts || getToAccounts(state),
	fromAccounts: props.fromAccounts || getFromAccounts(state),
	selectedPaymentId: getSelectedPaymentId(state),
	isLargeCustomerView: getIsLCV(state),
	selectedFromAccount: getSelectedFromAccount(state),
	currentPage: getPage(state),
	paymentType: getPaymentTypeOrPayeeType(state),
});
const mapDispatch = (dispatch) => ({
	setSelectedPaymentId: (id) => dispatch(setSelectedPaymentId(id)),
	setSelectedAccount: (fromAccount) => dispatch(setSelectedFromAccount(fromAccount)),
	goToPage: (page) => dispatch(goToPage(page)),
});

export default (WrappedComponent) => {
	const withAccountSelection = class extends Component {
		constructor(props) {
			super(props);

			this.state = {
				showFromAccountSelector: false,
			};

			this.handleFromCardClick = this.handleFromCardClick.bind(this);
			this.handleSelectFromAccount = this.handleSelectFromAccount.bind(this);
		}

		handleFromCardClick(paymentId) {
			const {
				isLargeCustomerView,
				goToPage,
				paymentType,
				selectedFromAccount,
				setSelectedAccount,
				setSelectedPaymentId,
			} = this.props;
			if (isLargeCustomerView) {
				// FIXME: need to clean and stop sending fromAccount as paymentId.
				if (paymentId && paymentId !== 'fromAccount') {
					setSelectedPaymentId(paymentId);
				}
				setSelectedAccount(selectedFromAccount);
				switch (paymentType) {
					case TYPE_IFT:
						goToPage(pages.IFTAccountPicker);
						break;
					case TYPE_FASTER_PAYMENTS:
						goToPage(pages.FasterPaymentsAccountPicker);
						break;
					case TYPE_CHAPS:
						goToPage(pages.ChapsAccountPicker);
						break;
					case TYPE_BACS_CREDIT:
						goToPage(pages.BacsCreditAccountPicker);
						break;
					case TYPE_BACS_DEBIT:
						goToPage(pages.BacsDebitAccountPicker);
						break;
					default:
						break;
				}
				return;
			}
			this.setState({
				showFromAccountSelector: !this.state.showFromAccountSelector,
			});
		}

		handleSelectFromAccount(accountId) {
			const {
				selectedPaymentId,
				updateFromAccount,
				setSelectedAccount,
				paymentType,
				handleSelectFromAccount,
				fromAccounts,
				handleSelectDestinationAccount,
				currentPage,
			} = this.props;
			this.setState({
				showFromAccountSelector: !this.state.showFromAccountSelector,
				fromAccount: accountId,
			});
			if ([pages.FasterPayments, pages.ChapsPayments].includes(currentPage)) {
				handleSelectFromAccount(accountId, fromAccounts);
			}
			if (TYPE_BACS_CREDIT.includes(paymentType)) {
				updateFromAccount({ id: selectedPaymentId, accountId });
			}
			if (TYPE_BACS_DEBIT.includes(paymentType)) {
				handleSelectDestinationAccount(accountId);
			}
			setSelectedAccount(accountId);
		}

		render() {
			return (
				<WrappedComponent
					{...{ ...this.props, ...this.state }}
					handleSelectFromAccount={this.handleSelectFromAccount}
					handleFromCardClick={this.handleFromCardClick}
				/>
			);
		}
	};

	withAccountSelection.displayName = `withAccountSelection(${
		WrappedComponent.displayName || WrappedComponent.name || 'Component'
	})`;

	withAccountSelection.propTypes = {
		isLargeCustomerView: PropTypes.bool.isRequired,
		setSelectedPaymentId: PropTypes.func.isRequired,
		id: PropTypes.string.isRequired,
		selectedPaymentId: PropTypes.string.isRequired,
		selectedFromAccount: PropTypes.string.isRequired,
		updateFromAccount: PropTypes.func.isRequired,
		setSelectedFromAccount: PropTypes.func.isRequired,
		goToPage: PropTypes.func.isRequired,
		setSelectedAccount: PropTypes.func.isRequired,
		currentPage: PropTypes.string.isRequired,
		paymentType: PropTypes.string.isRequired,
		handleSelectDestinationAccount: PropTypes.func.isRequired,
		handleSelectFromAccount: PropTypes.func,
		fromAccounts: PropTypes.arrayOf(accountPropTypes),
	};

	return connect(mapState, mapDispatch)(withAccountSelection);
};
